import { CircularProgress, Stack } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import { SPreviewContainer } from './styles';
import { useTranslation } from 'react-i18next';
import { Subscription } from 'rxjs';
import { PopupService } from '../popup/services/popup.service';
import { IPreviewPopup } from './preview.popup';
import { ISnackbarOptions, snackbarService } from '../snackbar/service/snackbar.service';
import { MessageRotator, MessageRotatorProps } from '../messageRotator/messageRotator.component';

export const Content: FC<IContent> = ({ stream, messagesForLongLoading }) => {
  const [link, setPDFLink] = useState<string>('');
  const { t } = useTranslation();

  const handleEmptyURL = () => {
    const snackArgs: ISnackbarOptions = {
      content: t('production.no_data_no_preview'),
      type: 'error',
    };
    snackbarService.pub.show(snackArgs);
    stream.emit('close');
  };

  useEffect(() => {
    let subId: Subscription | null = null;
    const openSub = stream.actionListener('open').subscribe(({ pub, sub }) => {
      subId = sub().subscribe({
        next: (v) =>
          v.url
            ? setPDFLink(v.url)
            : !v.disableEmptyUrlHandler
            ? handleEmptyURL()
            : stream.emit('close'),
      });
      pub();
    });
    return () => {
      setPDFLink('');
      subId?.unsubscribe?.();
      openSub.unsubscribe();
    };
  }, []);

  const messageRotator = useMemo(() => {
    const simpleLoading = (messagesForLongLoading ?? []).length === 0;
    if (simpleLoading) {
      return null;
    }
    return <MessageRotator uniqueMessages={messagesForLongLoading} sx={{ color: 'white' }} />;
  }, []);

  return (
    <SPreviewContainer link={link}>
      {!link ? (
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
            height: '100%',
          }}
        >
          <CircularProgress />
          {messageRotator}
        </Stack>
      ) : (
        <div className='iframe-container'>
          <iframe src={link + '#zoom=70'} title='PDF' />
        </div>
      )}
    </SPreviewContainer>
  );
};

export interface ReportRes {
  url: string | null | undefined;
  disableEmptyUrlHandler?: boolean;
}

export interface IContent {
  stream: PopupService<IPreviewPopup>;
  messagesForLongLoading?: MessageRotatorProps['uniqueMessages'];
}
